<template>
  <atomic-link class="special-menu-item" :class="type" @click="handleClick">
    <atomic-icon :id="icon" />

    <span class="special-menu-item__text">
        {{ label }}
    </span>

    <atomic-image v-if="props.cdnImage" :src="backgroundImage"  />
  </atomic-link>
</template>

<script setup lang="ts">
  const props = defineProps<{
    url: string;
    icon: string;
    label: string;
    type: string;
    cdnImage: string;
  }>();

  const {
    public: { gamehubCdn },
  } = useRuntimeConfig();

  const globalStore = useGlobalStore();
  const { layoutData, defaultLocaleLayoutData } = storeToRefs(globalStore);
  const router = useRouter();
  const { localizePath } = useProjectMethods();

  const backgroundImage = computed(() => {
    return `${gamehubCdn}${props.cdnImage}`;
  });

  const handleClick = (): void => {
    router.push(localizePath(`${props.url}`));
  };
</script>

<style src="~/assets/styles/components/atomic/menu/special.scss" lang="scss" />
